function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react/no-array-index-key */
// array maps being used are static, this is fine.

import React, { useCallback, useMemo, useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import TimeInput from "./TimeInput.js";
import StyleExports from "./TimeSlider.module.css";
import "./TimeSlider.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var HANDLE_SIZE = parseInt(StyleExports['handle-size'], 10);
var POPOVER_WIDTH = parseInt(StyleExports['popover-width'], 10);
var SECONDS_IN_DAY = 24 * 60 * 60 - 1; // Max is actually 23:59:59
var SNAP_NEAREST_MINUTES = 5 * 60; // rounds in 5 minute intervals

/**
 * Creates a time slider for setting a start and end time, that can also run overnight
 * @param props takes times in seconds 0 - 86399 and a callback
 */
function TimeSlider(_ref) {
  var propStartTime = _ref.startTime,
    propEndTime = _ref.endTime,
    onChange = _ref.onChange,
    _ref$isStartModified = _ref.isStartModified,
    isStartModified = _ref$isStartModified === void 0 ? false : _ref$isStartModified,
    _ref$isEndModified = _ref.isEndModified,
    isEndModified = _ref$isEndModified === void 0 ? false : _ref$isEndModified,
    dataTestId = _ref['data-testid'];
  var _useState = useState(propStartTime),
    _useState2 = _slicedToArray(_useState, 2),
    startTime = _useState2[0],
    setStartTime = _useState2[1];
  var _useState3 = useState(propEndTime),
    _useState4 = _slicedToArray(_useState3, 2),
    endTime = _useState4[0],
    setEndTime = _useState4[1];
  var track = useRef(null); // we need the track width while calulculating time from handle drag

  // updates state if props change
  useEffect(function setTimeOnPropTimeChange() {
    setStartTime(propStartTime);
    setEndTime(propEndTime);
  }, [propStartTime, propEndTime]);
  var updateTime = useCallback((newStartTime, newEndTime) => {
    var start = newStartTime;
    var end = newEndTime;
    if (start === end) {
      if (end < SECONDS_IN_DAY) {
        end += 1;
      } else {
        start -= 1;
      }
    }
    setStartTime(start);
    setEndTime(end);
    onChange({
      startTime: start,
      endTime: end
    });
  }, [setStartTime, setEndTime, onChange]);
  var handleStartTimeChange = useCallback(newStartTime => {
    updateTime(newStartTime, endTime);
  }, [updateTime, endTime]);
  var handleEndTimeChange = useCallback(newEndTime => {
    updateTime(startTime, newEndTime);
  }, [updateTime, startTime]);
  return /*#__PURE__*/_jsxs("div", {
    className: "time-slider",
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsx(PopOvers, {
      startTime: startTime,
      endTime: endTime,
      onStartTimeChange: handleStartTimeChange,
      onEndTimeChange: handleEndTimeChange,
      isStartModified: isStartModified,
      isEndModified: isEndModified
    }), /*#__PURE__*/_jsxs("div", {
      className: "track",
      ref: track,
      children: [/*#__PURE__*/_jsx(TrackFills, {
        startTime: startTime,
        endTime: endTime
      }), /*#__PURE__*/_jsx("div", {
        className: "ticks",
        children: Array(24).fill(null).map((value, index) => /*#__PURE__*/_jsx("div", {
          className: "tick"
        }, index))
      }), /*#__PURE__*/_jsx(Handle, {
        track: track,
        time: startTime,
        setTime: handleStartTimeChange
      }), /*#__PURE__*/_jsx(Handle, {
        track: track,
        time: endTime,
        setTime: handleEndTimeChange
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "tick-labels",
      children: [/*#__PURE__*/_jsx("div", {
        className: "tick-label",
        children: "0:00"
      }), /*#__PURE__*/_jsx("div", {
        className: "tick-label-wrapper",
        children: Array(24).fill(null).map((value, index) => /*#__PURE__*/_jsx("div", {
          className: "tick-label",
          children: "".concat(index + 1, ":00")
        }, index))
      })]
    })]
  });
}
function PopOvers(props) {
  var startTime = props.startTime,
    endTime = props.endTime,
    onStartTimeChange = props.onStartTimeChange,
    onEndTimeChange = props.onEndTimeChange,
    isStartModified = props.isStartModified,
    isEndModified = props.isEndModified,
    dataTestId = props['data-testid'];
  var swapTimes = startTime > endTime;
  var _useState5 = useState(swapTimes ? endTime : startTime),
    _useState6 = _slicedToArray(_useState5, 2),
    firstTime = _useState6[0],
    setFirstTime = _useState6[1];
  var _useState7 = useState(swapTimes ? startTime : endTime),
    _useState8 = _slicedToArray(_useState7, 2),
    secondTime = _useState8[0],
    setSecondTime = _useState8[1];
  var firstTimeRef = useRef(null);
  var secondTimeRef = useRef(null);
  // Keep track of selection in both time inputs
  var firstTimeSelectionRef = useRef(null);
  var secondTimeSelectionRef = useRef(null);
  useEffect(function setTimeOnPropTimeChange() {
    setFirstTime(startTime > endTime ? endTime : startTime);
    setSecondTime(startTime > endTime ? startTime : endTime);
  }, [startTime, endTime]);
  useEffect(function setFocusOnSwapTimesChange() {
    if (firstTimeSelectionRef.current !== null) {
      var _secondTimeRef$curren;
      (_secondTimeRef$curren = secondTimeRef.current) === null || _secondTimeRef$curren === void 0 || _secondTimeRef$curren.setSelection(firstTimeSelectionRef.current);
    }
    if (secondTimeSelectionRef.current !== null) {
      var _firstTimeRef$current;
      (_firstTimeRef$current = firstTimeRef.current) === null || _firstTimeRef$current === void 0 || _firstTimeRef$current.setSelection(secondTimeSelectionRef.current);
    }
  }, [swapTimes]);
  function onFirstTimeChange(value) {
    if (startTime <= endTime) {
      onStartTimeChange(value);
    } else {
      onEndTimeChange(value);
    }
  }
  function onSecondTimeChange(value) {
    if (startTime <= endTime) {
      onEndTimeChange(value);
    } else {
      onStartTimeChange(value);
    }
  }
  var onFirstTimeSelect = useCallback(selection => {
    firstTimeSelectionRef.current = selection;
    secondTimeSelectionRef.current = null;
  }, []);
  var onSecondTimeSelect = useCallback(selection => {
    firstTimeSelectionRef.current = null;
    secondTimeSelectionRef.current = selection;
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: "time-slider-popovers",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex",
      style: {
        flexBasis: "calc(".concat(firstTime / SECONDS_IN_DAY * 100, "% - ").concat(POPOVER_WIDTH / 2, "px)")
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: "handle-popper",
      children: [/*#__PURE__*/_jsx("label", {
        className: classNames({
          modified: swapTimes ? isEndModified : isStartModified
        }),
        children: swapTimes ? 'End Time' : 'Start Time'
      }), /*#__PURE__*/_jsx(TimeInput, {
        ref: firstTimeRef,
        allowValueWrapping: false,
        value: firstTime,
        onChange: onFirstTimeChange,
        onSelect: onFirstTimeSelect,
        "data-testid": dataTestId !== undefined ? "".concat(dataTestId, "-input-1") : undefined
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "flex-spacer"
    }), /*#__PURE__*/_jsxs("div", {
      className: "handle-popper",
      children: [/*#__PURE__*/_jsx("label", {
        className: classNames({
          modified: swapTimes ? isStartModified : isEndModified
        }),
        children: swapTimes ? 'Start Time' : 'End Time'
      }), /*#__PURE__*/_jsx(TimeInput, {
        ref: secondTimeRef,
        allowValueWrapping: false,
        value: secondTime,
        onChange: onSecondTimeChange,
        onSelect: onSecondTimeSelect,
        "data-testid": dataTestId !== undefined ? "".concat(dataTestId, "-input-2") : undefined
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "flex",
      style: {
        flexBasis: "calc(".concat((SECONDS_IN_DAY - secondTime) / SECONDS_IN_DAY * 100, "% - ").concat(POPOVER_WIDTH / 2, "px)")
      }
    })]
  });
}
/**
 * Shades the area between or outside of handles according to if start or endtime is greater.
 */
function TrackFills(props) {
  var startTime = props.startTime,
    endTime = props.endTime,
    dataTestId = props['data-testid'];
  return /*#__PURE__*/_jsxs("div", {
    className: "track-fills",
    "data-testid": dataTestId,
    children: [startTime > endTime && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "track-fill track-fill-start",
        style: {
          transform: "scaleX(".concat(endTime / SECONDS_IN_DAY, ")")
        }
      }), /*#__PURE__*/_jsx("div", {
        className: "track-fill track-fill-end",
        style: {
          transform: "scaleX(".concat((SECONDS_IN_DAY - startTime) / SECONDS_IN_DAY, ")")
        }
      })]
    }), startTime < endTime && /*#__PURE__*/_jsx("div", {
      className: "track-fill track-fill-middle",
      style: {
        transform: "translateX(".concat(startTime / SECONDS_IN_DAY * 100, "%) scaleX(").concat((endTime - startTime) / SECONDS_IN_DAY, ")")
      }
    })]
  });
}
/**
 * Creates a draggable handle the sets the time
 */
function Handle(props) {
  var track = props.track,
    time = props.time,
    setTime = props.setTime,
    dataTestId = props['data-testid'];

  /**
   * Takes the time and generate our translation string taking into account handle offset.
   * The handle offset changes for the first and last tick range dynmaically. Normally,
   * the center of the handle (size/2) is the selection origin, but at edges, it becomes either
   * end of the handle, requireing a relative offset range of 0 - 0.5,  and 0.5 - 1 of handle size.
   * @param t time in seconds
   */
  var transform = useMemo(() => {
    var ONE_HOUR = 60 * 60;
    var handleOffset = HANDLE_SIZE / 2;
    if (time < ONE_HOUR) {
      handleOffset = time / ONE_HOUR * (HANDLE_SIZE / 2); // 0 - 0.5 Handle size
    } else if (time > 23 * ONE_HOUR) {
      handleOffset = HANDLE_SIZE / 2 + 1 / (SECONDS_IN_DAY - 23 * ONE_HOUR) * (time - 23 * ONE_HOUR) * (HANDLE_SIZE / 2); // 0.5 - 1 Handle size
    }
    return "translateX(calc(".concat(time / SECONDS_IN_DAY * 100, "% - ").concat(handleOffset, "px))");
  }, [time]);
  var calculatePositionAsTime = useCallback(clientX => {
    if (!track.current) {
      return 0;
    }
    var trackRect = track.current.getBoundingClientRect();
    var leftEdge = Math.max(clientX - trackRect.left, 0);
    // get position as 0-1 on slider and mulitply by seconds in a day to convert to time
    var preciseTime = SECONDS_IN_DAY * Math.min(1, leftEdge / trackRect.width);
    // snap to nearest N(5) minute interval
    var roundedTime = SNAP_NEAREST_MINUTES * Math.round(preciseTime / SNAP_NEAREST_MINUTES);
    // prevent over-rounding to 24:00:00
    var limitMax = Math.min(SECONDS_IN_DAY, roundedTime);
    return limitMax;
  }, [track]);
  var handleMouseMove = useCallback(_ref2 => {
    var clientX = _ref2.clientX;
    setTime(calculatePositionAsTime(clientX));
  }, [setTime, calculatePositionAsTime]);
  var handleMouseUp = useCallback(_ref3 => {
    var clientX = _ref3.clientX;
    setTime(calculatePositionAsTime(clientX));
    window.removeEventListener('mousemove', handleMouseMove);
    window.removeEventListener('mouseup', handleMouseUp);
    document.documentElement.classList.remove('drag-pointer-events-none');
  }, [setTime, calculatePositionAsTime, handleMouseMove]);
  var startDragListening = useCallback(() => {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    document.documentElement.classList.add('drag-pointer-events-none');
  }, [handleMouseMove, handleMouseUp]);
  var stopDragListening = useCallback(() => {
    window.removeEventListener('mousemove', handleMouseMove);
    window.removeEventListener('mouseup', handleMouseUp);
    document.documentElement.classList.remove('drag-pointer-events-none');
  }, [handleMouseMove, handleMouseUp]);
  var handleMouseDown = useCallback(() => {
    startDragListening();
  }, [startDragListening]);
  useEffect(function removeListenersOnUnmount() {
    return () => {
      stopDragListening();
    };
  }, [stopDragListening]);
  return /*#__PURE__*/_jsx("div", {
    className: "handle-track",
    style: {
      transform
    },
    children: /*#__PURE__*/_jsx("button", {
      className: "handle",
      type: "button",
      "aria-label": "Change time",
      onMouseDown: handleMouseDown,
      "data-testid": dataTestId
    })
  });
}
export default TimeSlider;
//# sourceMappingURL=TimeSlider.js.map